import React, { useState, useEffect } from 'react'
import { Table, Form, Input, Select, Button, Space, Tag } from 'antd'

const initialSearch = {
  name: '',
  active: '',
  riskOnly: false,
}

// YYYYMMDD -> YYYY-MM-DD
const fmtDate = (d) => {
  if (!d) return '-'
  const s = String(d)
  if (s.length === 8) return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
  return s
}

const GifticonList = (props) => {
  const { loading, gifticons, updateGifticon, syncGoods } = props

  const [search, setSearch] = useState(initialSearch)
  const [results, setResults] = useState([])

  useEffect(() => {
    setResults(
      gifticons
        .filter((g) => !search.active || search.active === g.active)
        .filter((g) => !search.name || (g.name && g.name.includes(search.name)))
        .filter(
          (g) => !search.riskOnly || (g.giftishowLive === 'N' && g.useCount > 0)
        )
    )
  }, [gifticons, search])

  const handleInputChange = (e) =>
    setSearch({ ...search, [e.target.name]: e.target.value })

  const handleActiveChange = (value) => setSearch({ ...search, active: value })

  const columns = [
    { title: '상품명', dataIndex: 'name' },
    { title: '브랜드', dataIndex: 'brand' },
    { title: '가격', dataIndex: 'price' },
    { title: '상태', dataIndex: 'state' },
    { title: '만료일', dataIndex: 'validPrdDay', render: fmtDate },
    {
      title: '기프티쇼',
      dataIndex: 'giftishowLive',
      render: (live) =>
        live === 'N' ? (
          <Tag color="red">단종</Tag>
        ) : (
          <Tag color="green">판매중</Tag>
        ),
    },
    {
      title: '대체상품',
      render: (_, g) =>
        g.replacementCode ? (
          <span>
            {g.replacementCode}
            <br />
            <small style={{ color: 'gray' }}>~{fmtDate(g.replacementValidPrdDay)}</small>
          </span>
        ) : (
          '-'
        ),
    },
    {
      title: '사용매장',
      dataIndex: 'useCount',
      render: (cnt, g) => {
        // 단종인데 대체상품도 없이 매장이 쓰는 중 = 발송 불가 위험
        const danger = g.giftishowLive === 'N' && cnt > 0 && !g.replacementCode
        return (
          <span style={{ color: danger ? 'red' : undefined, fontWeight: danger ? 'bold' : undefined }}>
            {cnt}
            {danger ? ' ⚠' : ''}
          </span>
        )
      },
    },
    {
      title: '노출',
      dataIndex: 'active',
      render: (active, gifticon) =>
        active === 'Y' ? (
          <Button type="primary" onClick={() => updateGifticon(gifticon.code, 'N')}>
            노출중
          </Button>
        ) : (
          <Button type="primary" danger onClick={() => updateGifticon(gifticon.code, 'Y')}>
            미노출
          </Button>
        ),
    },
  ]

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <Space>
          <Button onClick={syncGoods}>기프티쇼 동기화</Button>
          <Button
            danger={search.riskOnly}
            type={search.riskOnly ? 'primary' : 'default'}
            onClick={() => setSearch({ ...search, riskOnly: !search.riskOnly })}
          >
            ⚠ 단종+사용중만
          </Button>
        </Space>
        <Form layout="inline">
          <Form.Item>
            <Select
              defaultValue=""
              value={search.active}
              onChange={handleActiveChange}
              style={{ width: 150 }}
            >
              <Select.Option value="">= 노출 선택 =</Select.Option>
              <Select.Option value="Y">노출중</Select.Option>
              <Select.Option value="N">미노출</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Input
              name="name"
              prefix={
                <span style={{ fontWeight: 'bold', color: 'gray' }}>이름: </span>
              }
              value={search.name}
              onChange={handleInputChange}
              style={{ width: 200 }}
            />
          </Form.Item>
        </Form>
      </div>
      <Table
        columns={columns}
        dataSource={results}
        rowKey={(gifticon) => gifticon.id}
        loading={loading}
      />
    </div>
  )
}

export default GifticonList
